var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_144",
    "data-name": "Group 144",
    xmlns: "http://www.w3.org/2000/svg",
    width: 188.446,
    height: 185.297,
    viewBox: "0 0 188.446 185.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2573",
    "data-name": "Path 2573",
    d: "M189.582,102.258h48.824a8.667,8.667,0,0,0,8.641-8.641V83.062c-2.1-16.11-1.975-30.307,0-47.281V26.336L193.594,17.88,180.94,65.593V93.617a8.667,8.667,0,0,0,8.642,8.642h0Z",
    transform: "translate(-120.388 82.916)",
    fill: "#ffbe71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2574",
    "data-name": "Path 2574",
    d: "M208.85,18.182l2.222-8.518a1.172,1.172,0,0,1,1.481-.864,1.119,1.119,0,0,1,.864.926l2.037,8.518a11.9,11.9,0,0,0,7.839,8.456l4.383,1.42a1.277,1.277,0,0,1,.8,1.543,1.3,1.3,0,0,1-.8.8L223.541,31.7a11.708,11.708,0,0,0-8.086,8.641l-1.914,8.148a1.226,1.226,0,0,1-1.481.926,1.391,1.391,0,0,1-.926-.926l-1.79-7.963a11.738,11.738,0,0,0-8.024-8.641l-4.568-1.42a1.249,1.249,0,0,1-.8-1.543,1.2,1.2,0,0,1,.741-.8l4.753-1.667a11.783,11.783,0,0,0,7.469-8.148h0Z",
    transform: "translate(-42.996 35.703)",
    fill: "#ffbe71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2575",
    "data-name": "Path 2575",
    d: "M233.651,20.78H190.32a6.77,6.77,0,0,0-6.79,6.79h0v33.7a6.77,6.77,0,0,0,6.79,6.79h43.331Z",
    transform: "translate(-106.991 97.916)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2576",
    "data-name": "Path 2576",
    d: "M212.535,30.506H204.45V22.42H193.586v8.086H185.5V41.37h8.086v8.086H204.45V41.37h8.086Z",
    transform: "translate(-96.801 106.399)",
    fill: "#f74f73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2577",
    "data-name": "Path 2577",
    d: "M198.682,28.5h14.937a9.567,9.567,0,1,1,0,19.135H198.682c-1.42-6.975-1.728-13.518,0-19.2Z",
    transform: "translate(-34.74 137.537)",
    fill: "#7aaeed"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2578",
    "data-name": "Path 2578",
    d: "M203.287,28.45h14.937v19.2H203.287a9.567,9.567,0,1,1,0-19.135h0Z",
    transform: "translate(-54.283 137.589)",
    fill: "#3a7cca"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2579",
    "data-name": "Path 2579",
    d: "M221.451,53.11a17.984,17.984,0,0,1-21.665-3.271l-4.506-8.209A17.993,17.993,0,0,1,225.71,24.84l4.506,8.209a18.035,18.035,0,0,1-8.827,20.061Z",
    transform: "translate(-48.868 90.338)",
    fill: "#3a7cca"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    d: "M194.85,36.989a18.232,18.232,0,0,0,4.506,8.209l30.492-16.789a18.232,18.232,0,0,0-4.506-8.209Z",
    transform: "translate(-48.438 94.916)",
    fill: "#3a7cca"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 2.222,
    cy: 2.222,
    rx: 2.222,
    ry: 2.222,
    transform: "translate(166.534 25.923)",
    fill: "#ffbe71"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    d: "M180.94,16.8h66.107V31.923H180.94Z",
    transform: "translate(-120.388 77.329)",
    fill: "#ef8e4d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    d: "M183.89,33.624H237.9V21.958a6.744,6.744,0,0,0-6.728-6.728H191.235c-3.642,6.3-6.419,12.407-7.284,18.394Z",
    transform: "translate(-105.129 69.209)",
    fill: "#ffbe71"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    d: "M186.688,15.24a6.744,6.744,0,0,0-6.728,6.728V33.634h24.2L211.44,15.24H186.626Z",
    transform: "translate(-125.457 69.26)",
    fill: "#ef8e4d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    d: "M202.605,16.8H180.94V71.241Z",
    transform: "translate(-120.388 77.329)",
    fill: "#ef8e4d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2585",
    "data-name": "Path 2585",
    d: "M184.637,47.287A2.055,2.055,0,0,1,182.6,45.25a1.566,1.566,0,0,1,.123-.741L199.266,2.845a2.1,2.1,0,0,1,2.654-1.173,2.079,2.079,0,0,1,1.173,2.654L186.55,45.991A2.007,2.007,0,0,1,184.637,47.287Z",
    transform: "translate(-111.802 -1.55)",
    fill: "#7aaeed"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2586",
    "data-name": "Path 2586",
    d: "M184.52,11.262l2.222-8.518a1.2,1.2,0,0,1,1.481-.864,1.119,1.119,0,0,1,.864.926l2.037,8.518a11.9,11.9,0,0,0,7.839,8.456l4.383,1.42a1.277,1.277,0,0,1,.8,1.543,1.3,1.3,0,0,1-.8.8l-4.136,1.234a11.708,11.708,0,0,0-8.086,8.641l-1.914,8.148a1.226,1.226,0,0,1-1.481.926,1.391,1.391,0,0,1-.926-.926l-1.79-7.963a11.738,11.738,0,0,0-8.024-8.641l-4.568-1.42a1.249,1.249,0,0,1-.8-1.543,1.2,1.2,0,0,1,.741-.8l4.753-1.667a11.783,11.783,0,0,0,7.469-8.148Z",
    transform: "translate(-168.842 -0.091)",
    fill: "#ffbe71"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2587",
    "data-name": "Path 2587",
    d: "M187.394,8l8.333,3.271a2.339,2.339,0,0,1,1.3,3.086L194.245,21.4h0L181.53,16.336h0L184.308,9.3a2.42,2.42,0,0,1,3.086-1.358h0Z",
    transform: "translate(-117.336 30.759)",
    fill: "#7aaeed"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    d: "M189.88,9.195l14.2,5.617a4.031,4.031,0,0,1,2.284,5.247l-4.753,11.975h0L179.88,23.391h0l4.753-11.975a4.031,4.031,0,0,1,5.247-2.284h0Z",
    transform: "translate(-125.871 36.234)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M188.892,9.022l16.172,6.419a2.979,2.979,0,0,1,1.667,3.889h0l-5.123,12.962h0L179.88,23.651h0L185,10.689a2.979,2.979,0,0,1,3.889-1.667Z",
    transform: "translate(-125.871 35.974)",
    fill: "#497fce"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M206.823,104.936,173.8,91.85l31.048-78.206a4.6,4.6,0,0,1,5.987-2.592h0l24.443,9.691a4.6,4.6,0,0,1,2.592,5.987h0l-3.7,9.32a4.727,4.727,0,0,0-1.481,3.827l-3.148,7.9a6.691,6.691,0,0,0-1.481,3.827l-3.148,7.9a5.817,5.817,0,0,0-1.481,3.827l-3.148,7.9a7.149,7.149,0,0,0-1.481,3.827l-3.148,7.9a8.3,8.3,0,0,0-1.481,3.827l-7.222,18.147Z",
    transform: "translate(-157.32 45.919)",
    fill: "#79adea"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M182.238,25.04,193.1,29.361l-8.148,20.493L174.09,45.533Z",
    transform: "translate(-155.819 119.951)",
    fill: "#497fce"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(0 79.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M179.4,27.766l31.727,12.592a4.4,4.4,0,0,1,2.469,5.679l-2.654,6.728h0l-39.813-15.8h0l2.654-6.728a4.4,4.4,0,0,1,5.679-2.469Z",
    transform: "translate(-171.13 53.427)",
    fill: "#7aaeed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 11.604,
    height: 44.936,
    rx: 0.52,
    transform: "translate(9.388 63.645) rotate(-68.36)",
    fill: "#7aaeed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M184.818,14.514a2.052,2.052,0,1,0-1.481,3.827l6.79,2.716,1.481-3.827-6.79-2.716Z",
    transform: "translate(-114.822 -14.366)",
    fill: "#3a7cca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    d: "M184.068,16.414a2.052,2.052,0,0,0-1.481,3.827l6.79,2.716,1.482-3.827-6.79-2.716Z",
    transform: "translate(-118.701 -4.538)",
    fill: "#3a7cca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    d: "M182.578,18.024A2.052,2.052,0,1,0,181.1,21.85l11.3,4.506,1.481-3.827-11.3-4.506Z",
    transform: "translate(-126.408 3.789)",
    fill: "#3a7cca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M182.565,20.231A2.035,2.035,0,0,0,181.022,24h0l6.79,2.716,1.481-3.827-6.79-2.716Z",
    transform: "translate(-126.519 15.161)",
    fill: "#3a7cca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M181.808,22.124a2.052,2.052,0,1,0-1.481,3.827h0l6.79,2.716,1.543-3.827-6.79-2.716Z",
    transform: "translate(-130.391 24.997)",
    fill: "#3a7cca"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.09b7aa1fb048c759992eb2c8f66a63b3.svg";
export { ForwardRef as ReactComponent };